import axios from 'axios';
import { API_BASE_URL } from '../../config';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Clients API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

const clientsService = {
  getClients: () => {
    return api.get('/clients');
  },

  getClient: (id) => {
    return api.get(`/clients/${id}`);
  },

  getClientApps: (id) => {
    return api.get(`/clients/${id}/apps`);
  },

  getClientStats: (id) => {
    return api.get(`/clients/${id}/stats`);
  },

  getClientScripts: (id) => {
    return api.get(`/clients/${id}/scripts`);
  },

  testClientConnection: (id) => {
    return api.get(`/clients/${id}/connection-test`);
  },

  getScriptClients: (scriptId) => {
    return api.get(`/scripts/${scriptId}/clients`);
  },

  getScriptResults: (scriptId) => {
    return api.get(`/scripts/${scriptId}/results`);
  },
};

export { clientsService };
export default clientsService;
